import { Link, useLocation, Navigate } from "react-router-dom";

function VanshavaliThankYou() {
  const location = useLocation();
  const formNumber = location.state?.formNumber;

  if (!formNumber) return <Navigate to="/vanshavali/form" replace />;

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center p-5">
              <div
                className="mx-auto mb-4 d-flex align-items-center justify-content-center"
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  background: "rgba(40, 167, 69, 0.12)",
                  color: "#28a745",
                }}
              >
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>

              <h2 className="fw-bold mb-2">Thank you!</h2>
              <p className="text-muted mb-4">
                Your Vanshavali form has been submitted successfully.
              </p>

              <div className="bg-light rounded-3 p-3 mb-4">
                <div className="text-muted small text-uppercase fw-semibold mb-1">
                  Your Form Number
                </div>
                <div className="fw-bold" style={{ fontSize: "1.5rem", color: "orange" }}>
                  {formNumber}
                </div>
              </div>

              <p className="small text-muted mb-4">
                Please save this form number for your records.
                Approval and updates to the published Vanshavali typically take{" "}
                <strong>3 to 6 months</strong>, depending on review by the
                committee.
              </p>

              <Link to="/vanshavali" className="btn btn-primary px-4">
                Back to Vanshavali
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VanshavaliThankYou;
